import { requester } from '../utils';

export const getAmenitiesList = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/amenity`,
        method: 'GET',
        withAuth: false,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get amenities list error', err);
        reject(err);
      });
  });
};
